/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpgatesAddonOpen200Response
 */
export interface UpgatesAddonOpen200Response {
    /**
     * 
     * @type {string}
     * @memberof UpgatesAddonOpen200Response
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgatesAddonOpen200Response
     */
    type?: string;
}

/**
 * Check if a given object implements the UpgatesAddonOpen200Response interface.
 */
export function instanceOfUpgatesAddonOpen200Response(value: object): value is UpgatesAddonOpen200Response {
    return true;
}

export function UpgatesAddonOpen200ResponseFromJSON(json: any): UpgatesAddonOpen200Response {
    return UpgatesAddonOpen200ResponseFromJSONTyped(json, false);
}

export function UpgatesAddonOpen200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpgatesAddonOpen200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'] == null ? undefined : json['url'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function UpgatesAddonOpen200ResponseToJSON(json: any): UpgatesAddonOpen200Response {
    return UpgatesAddonOpen200ResponseToJSONTyped(json, false);
}

export function UpgatesAddonOpen200ResponseToJSONTyped(value?: UpgatesAddonOpen200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'type': value['type'],
    };
}

